import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 39,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 md:px-8 bg-red-50" data-id="element-229">
      <div className="max-w-4xl mx-auto text-center" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-231">
          <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-232">
            🤍 +2.800 familias ya guardaron la historia de su mamá este mes
          </p>
          <p className="text-[#D32F2F] font-bold text-xl mb-6" data-id="element-233">
            ⏳ Esta oferta especial vence en:
          </p>

          <div className="flex justify-center gap-4 text-center" data-id="element-234">
            <div className="bg-white rounded-lg p-4 shadow-lg min-w-[80px]" data-id="element-235">
              <div className="text-3xl md:text-4xl font-bold text-[#D32F2F]" data-id="element-236">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 mt-1" data-id="element-237">HORAS</div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-lg min-w-[80px]" data-id="element-238">
              <div className="text-3xl md:text-4xl font-bold text-[#D32F2F]" data-id="element-239">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 mt-1" data-id="element-240">MINUTOS</div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-lg min-w-[80px]" data-id="element-241">
              <div className="text-3xl md:text-4xl font-bold text-[#D32F2F]" data-id="element-242">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 mt-1" data-id="element-243">SEGUNDOS</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}